import RichTextCopy from 'components/shared/RichTextCopy/RichTextCopy';
import { ContentfulRichTextBlock } from 'libs/contentful/props';
import { Alignment } from 'types/constants';
import { getAlignment } from 'utils/styles';

interface MediaCopyCopyItemProps {
  alignment: Alignment;
  copy: ContentfulRichTextBlock;
}
const MediaCopyCopyItem = ({ alignment, copy }: MediaCopyCopyItemProps) => {
  return (
    <div className={`flex flex-[1_0_100%] flex-col ${getAlignment(alignment)}`}>
      <div className="flex items-center">
        <div className="font-serif font-body-serif text-lg mt-6 w-full max-w-[690px]">
          <RichTextCopy copy={copy} />
        </div>
      </div>
    </div>
  );
};

export default MediaCopyCopyItem;
